const ImagesFactory = require('../images');

module.exports = Backbone.Model.extend({
  url: function () {
    return this.baseUrl + (this.id ? 'images/' + this.id : 'images');
  },

  parse: function (resource) {
    if (Array.isArray(resource)) {
      return resource.map(this.parse, this);
    }

    const source = resource.data.source;

    resource.data.tab = ImagesFactory.getVersionUrl(source, 'tab');
    resource.data.web = ImagesFactory.getVersionUrl(source, 'web');
    resource.data.thumb = ImagesFactory.getVersionUrl(source, 'thumb');
    resource.data.mobile = ImagesFactory.getVersionUrl(source, 'mobile');
    resource.data.largeweb = ImagesFactory.getVersionUrl(source, 'largeweb');
    resource.data.original = source;

    ImagesFactory.setImagesData(
      { version: resource.data },
      'library', ImagesFactory.defaultAmazonDataNames
    );

    return resource;
  }
});
